module.exports = __webpack_public_path__ + "static/media/coinsilium.d8c021a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/coinsilium.png
// module id = 1826
// module chunks = 146